export default __webpack_public_path__ + "c4cf687e69da41c405ea7a774ce4997a.svg";